export const STATUS_LABELS = { backlog: 'À faire', inprogress: 'En cours', done: 'Terminée', canceled: 'Annulée' };
export const PRIORITY_LABELS = { low: 'Faible', medium: 'Normale', high: 'Haute', urgent: 'Urgente' };
export const idOf = value => String(value?._id || value || '');
export const personName = user => [user?.name, user?.lastname].filter(Boolean).join(' ') || user?.username || 'Utilisateur';
export const userStoreIds = user => [user?.default_store_id, ...(user?.affected_store_ids || [])].map(idOf).filter(Boolean);
export const canEditTask = (task, userId, roles, storeIds, managedUserIds = []) => {
  if (typeof task.permissions?.canEdit === 'boolean') return task.permissions.canEdit;
  if (roles.includes('admin')) return true;
  if (!roles.includes('manager')) return false;
  if (task.targetType === 'store') return storeIds.includes(idOf(task.store_id));
  return (task.assignees || []).some(user => [idOf(userId), ...managedUserIds.map(idOf)].includes(idOf(user)));
};
export const filterTasks = (tasks, { scope = 'all', userId, store = '', status = '', search = '' }) => tasks.filter(task => {
  if (scope === 'mine' && !(task.assignees || []).some(user => idOf(user) === idOf(userId))) return false;
  if (scope === 'store' && task.targetType !== 'store') return false;
  if (store && idOf(task.store_id) !== store) return false;
  if (status && task.status !== status) return false;
  return !search || `${task.title} ${task.description || ''}`.toLocaleLowerCase().includes(search.toLocaleLowerCase());
});
